import React, { useEffect, useState } from 'react';
import config from '../config';
import { Link, useParams } from 'react-router-dom';
import { fetchAuthSession } from 'aws-amplify/auth';

const BookBuilderPage = ({ testMode = false }) => {

    // const host = testMode ? config.testBackendUrl : config.backendUrl;
    const host = config.backendUrl;
    const productId = useParams().productId;

    let page = useParams().page;
    page = parseInt(page, 10); // Convert page to integer

    const [product, setProduct] = useState(null);
    const [pageDetails, setPageDetails] = useState(null);
    const [authToken, setAuthToken] = useState('');
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getAuthToken = async () => {
            try {
                const session = await fetchAuthSession();
                const token = session.tokens.idToken.toString();
                setAuthToken(token);
            } catch (error) {
                console.error('Error getting auth token:', error);
            }
        };
        
        getAuthToken();
    }, []);


    useEffect(() => {
        if (!authToken || !productId) return; // Don't fetch if no token or productId yet

        setLoading(true);
        fetch(`${host}/api/products/${productId}`, {
            headers: {
                "X-API-KEY": process.env.REACT_APP_GANDF_KEY,
                'Content-Type': 'application/json',
            }
        })
        .then(response => {
            if (!response.ok) {
                console.error('Network response was not ok', response);
            }
            return response.json();
        })
        .then(data => {
            setProduct(data);
            setPageDetails(data.pages[page])
            setLoading(false);
        })
        .catch(error => {
            console.error('Error fetching product details:', error);
            setLoading(false);
        });
    }, [authToken, productId]);

    const handleSave = async () => {
        if (!authToken || !product || pageDetails === null) {
            console.error('No auth token or product available');
            return;
        }

        const updatedPages = product.pages.map((p, index) => index === page ? pageDetails : p);

        const updatedProduct = {
            ...product,
            pages: updatedPages
        };

        try {
            const response = await fetch(`${host}/api/admin/products/${product.id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
                body: JSON.stringify(updatedProduct)
            });
            
            if (!response.ok) {
                console.error('Failed to save product changes', response);
                return;
            }
            alert('Product saved successfully!');
        }
        catch (error) {
            console.error('Error saving product:', error);
        }
    }
    
    if (loading) {
        return (
            <div className="main-content">
                <div style={{ textAlign: 'center', padding: 'var(--spacing-3xl)' }}>
                    <div className="spinner" style={{ margin: '0 auto' }}></div>
                    <p style={{ marginTop: 'var(--spacing-md)', color: 'var(--text-secondary)' }}>
                        Loading product details...
                    </p>
                </div>
            </div>
        );
    }

    if (!product) {
        return (
            <div className="main-content">
                <div className="card">
                    <div className="card-body" style={{ textAlign: 'center', padding: 'var(--spacing-3xl)' }}>
                        <div style={{ fontSize: '3rem', marginBottom: 'var(--spacing-lg)' }}>❌</div>
                        <h3 style={{ marginBottom: 'var(--spacing-md)' }}>Product Not Found</h3>
                        <p style={{ color: 'var(--text-secondary)' }}>
                            The product you're looking for doesn't exist or has been removed.
                        </p>
                        <Link to={testMode ? "/test/products" : "/products"} className="btn btn-primary">
                            Back to Products
                        </Link>
                    </div>
                </div>
            </div>
        );
    }


    if (!pageDetails) {
        return (
            <div className="main-content">
                <div className="card">
                    <div className="card-body" style={{ textAlign: 'center', padding: 'var(--spacing-3xl)' }}>
                        <div style={{ fontSize: '3rem', marginBottom: 'var(--spacing-lg)' }}>❌</div>
                        <h3 style={{ marginBottom: 'var(--spacing-md)' }}>Page Not Found</h3>
                        <p style={{ color: 'var(--text-secondary)' }}>
                            The page you're looking for doesn't exist or has been removed.
                        </p>
                        <Link to={testMode ? `/test/book-builder/${productId}` : `/book-builder/${productId}`} className="btn btn-primary">
                            Back to Product
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="main-content">
            {/* Page Header */}
            <div className="page-header">
                <div className="page-header-left">
                    <h1 className="page-header-title">
                        Book Builder - Page {page + 1}
                        {testMode && <span style={{color: 'var(--warning-color)'}}> (Test Mode)</span>}
                    </h1>
                </div>
                <div className="page-header-actions">
                    <Link to={testMode ? `/test/book-builder/${productId}` : `/book-builder/${productId}`} className="btn btn-secondary">
                        ← Back to Product
                    </Link>
                    <button className="btn btn-primary" onClick={handleSave}>
                        Save Changes
                    </button>
                </div>
            </div>

            <div className="table-actions">
                <button className="btn" onClick={() => {
                    setPageDetails({
                        ...pageDetails,
                        images: [...(pageDetails.images || []), ""]
                    })
                }}> + Add New Image</button>
            </div>

            {/* Product Information */}
            <div className="card">
                <div className="card-header">
                    <h3 className="card-title">Page {page + 1} Images</h3>
                </div>
                <div className="card-body">
                    {/* List page links for each page in product.pages */}
                    {pageDetails && pageDetails.images.length > 0 ? (
                        <ol>
                            {pageDetails.images.map((image, index) => (
                                <li key={index} style={{display: "flex", alignItems: "center", gap: "10px"}}>
                                    <span>{index + 1}. </span>
                                    <input 
                                        type="text"
                                        className="form-input"
                                        value={pageDetails.images[index]}
                                        onChange={(e) => setPageDetails({
                                            ...pageDetails,
                                            images: pageDetails.images.map((img, imgIndex) => imgIndex === index ? e.target.value : img)
                                        })}
                                    />
                                    <button className="btn btn-ghost" onClick={() => {
                                        setPageDetails({
                                            ...pageDetails,
                                            images: pageDetails.images.filter((_, imgIndex) => imgIndex !== index)
                                        })
                                    }}>❌</button>
                                </li>
                            ))}
                        </ol>
                    ) : (
                        <p>No images found.</p>
                    )}
                </div>
            </div>

            <br/>

            <div className="table-actions">
                <button className="btn" onClick={() => {
                    setPageDetails({
                        ...pageDetails,
                        text: [...(pageDetails.text || []), { line: "" }]
                    })
                }}> + Add New Text</button>
            </div>

            {/* Product Information */}
            <div className="card">
                <div className="card-header">
                    <h3 className="card-title">Page {page + 1} Text</h3>
                </div>
                <div className="card-body">
                    {/* List page links for each page in product.pages */}
                    {pageDetails && pageDetails.text && pageDetails.text.length > 0 ? (
                        <ul>
                            {pageDetails.text.map((text, index) => (
                                <li key={index} style={{display: "flex", alignItems: "center", gap: "10px"}}>
                                    <span>{index + 1}. </span>
                                    <input
                                        type="text"
                                        className="form-input"
                                        value={text.line.replaceAll("\n", "\\n")}
                                        onChange={(e) => {
                                            const newText = pageDetails.text.map((t, tIndex) => tIndex === index ? { line: e.target.value } : t);
                                            setPageDetails({
                                                ...pageDetails,
                                                text: newText
                                            });
                                        }}
                                    />
                                    <button className="btn btn-ghost" onClick={() => {
                                        setPageDetails({
                                            ...pageDetails,
                                            text: pageDetails.text.filter((_, tIndex) => tIndex !== index)
                                        })
                                    }}>❌</button>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <p>No text found.</p>
                    )}
                </div>
            </div>


            <br/>

            <div className="table-actions">
                <button className="btn" onClick={() => {
                    setPageDetails({
                        ...pageDetails,
                        rules: {...(pageDetails.rules || {}), "": ""}
                    })
                }}> + Add New Rule</button>
            </div>

            {/* Product Information */}
            <div className="card">
                <div className="card-header">
                    <h3 className="card-title">Page {page + 1} Rules</h3>
                </div>
                <div className="card-body">
                    {/* List page links for each page in product.pages */}
                    {pageDetails && pageDetails.rules ? (
                        <ol>
                            {Object.keys(pageDetails.rules).map((rule, index) => (
                                <li key={index}>
                                   <div style={{display: 'flex'}}>
                                        <input 
                                            type="text"
                                            className="form-input"
                                            value={rule}
                                            onChange={(e) => {
                                                const oldRules = { ...pageDetails.rules };
                                                const newRules = {};
                                                const ruleKeys = Object.keys(oldRules);
                                                ruleKeys.forEach((r, rIndex) => {
                                                    const newKey = rIndex === index ? e.target.value : r;
                                                    newRules[newKey] = oldRules[r];
                                                });
                                                setPageDetails({
                                                    ...pageDetails,
                                                    rules: newRules
                                                });
                                            }}
                                        />

                                        <span>=</span>


                                        <input 
                                            type="text"
                                            className="form-input"
                                            value={pageDetails.rules[rule]}
                                            onChange={(e) => {
                                                const oldRules = { ...pageDetails.rules };
                                                oldRules[rule] = e.target.value;
                                                setPageDetails({
                                                    ...pageDetails,
                                                    rules: oldRules
                                                });
                                            }}
                                        />

                                        <button className="btn btn-ghost" onClick={() => {
                                            const newRules = {};
                                            Object.keys(pageDetails.rules).forEach((r, rIndex) => {
                                                if (rIndex !== index) {
                                                    newRules[r] = pageDetails.rules[r];
                                                }
                                            });
                                            setPageDetails({
                                                ...pageDetails,
                                                rules: newRules
                                            });
                                        }}>❌</button>
                                   </div>
                                </li>
                            ))}
                        </ol>
                    ) : (
                        <p>No rules found.</p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default BookBuilderPage;